module.exports = __webpack_public_path__ + "static/home-solutions-consultancy-d854182014f187992b691a8dbbf720dd.svg";